import getConfig from 'next/config'

export const FILE_PATH = getConfig().publicRuntimeConfig.fileSourceBasePath

export const filePathUriBuilder = (filePath: string): string =>
  filePath ? `${FILE_PATH}scm/view?path=${filePath}` : ''
